import React from 'react';
import { render } from 'react-dom';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import reducer from './reducers';
import loadTasksList from './fetch';
import { tasksListLoaded } from "./actions";
import 'bootstrap/dist/css/bootstrap.css';
import './index.scss';
import App from './components/app';
import MainPage from "./components/mainPage";
import TaskDetails from "./components/taskDetails";

let store = createStore(reducer);
export default store;

if (!window.localStorage.getItem('tasksList')) {
    loadTasksList();
} else {
    let tasksList = JSON.parse(window.localStorage.getItem('tasksList'));
    store.dispatch(tasksListLoaded(tasksList));
}

render(
    <Provider store={store}>
        <BrowserRouter>
            <App>
                <Switch>
                    <Route exact path='/' component={MainPage} />
                    <Route path='/task-details' component={props => <TaskDetails {...props} />}/>
                </Switch>
            </App>
        </BrowserRouter>
    </Provider>,
    document.getElementById('root'));